import Icon from './Icon';

type Props = {
  size?: number;
  className?: string;
};

const StarRating = ({ size = 24, className }: Props) => (
  <div className="flex items-center gap-1">
    {[1, 2, 3, 4, 5].map((el) => (
      <Icon
        key={el}
        icon="material-symbols:star-rounded"
        fontSize={size}
        className={className ?? 'text-jb-secondary-400'}
      />
    ))}
  </div>
);

export default StarRating;
